<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="warningRecordTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="state" slot-scope="scope">
          <span>{{scope.row.state | FILTER_Warning_State}}</span>
        </template>
        <template slot="countCurrent" slot-scope="scope">
          <span>{{ $wtUtil.transWeight(scope.row.countCurrent) }}kg</span>
        </template>
        <template slot="countReal" slot-scope="scope">
          <span>{{$wtUtil.transWeight(scope.row.countReal)}}kg</span>
        </template>
        <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
          <wt-auth class="search-form-btn">
            <el-button v-if="scope.row.state === 1" :hasAnyPremission="form.formCode + ':DELAY'" size="mini" :type="'primary'" @click="toClickAction(scope.row, 'DELAY')">延迟</el-button>
            <el-button v-if="scope.row.state === 1" :hasAnyPremission="form.formCode + ':SOLVE'" size="mini" :type="'primary'" @click="toClickAction(scope.row, 'CONFIRM')">解决</el-button>
            <el-button v-if="scope.row.state !== 1" :hasAnyPremission="form.formCode + ':VIEW'" size="mini" :type="'primary'" @click="toClickAction(scope.row, 'VIEW')">查看</el-button>
          </wt-auth>
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <el-dialog
      :title="formDialog.title"
      :visible.sync="formDialog.visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
      key="1"
      :modal="false"
      :before-close="handleDialogClose">
      <div>
        <el-form v-if="formDialog.visible" :model="formDialog.form" ref="warningRecordForm">
          <el-form-item :label="''" prop="reason"
            :rules="[
              { required: true, message: formDialog.title + '不能为空'}
            ]"
          >
            <el-input type="textarea" v-model.trim="formDialog.form.reason" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleDialogClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('warningRecordForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'WarningRecord',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_WARNINGRECORD',
        formComponent: {
          view: { type: 'component', componentName: 'WarningRecordViewPage', noRequest: true },
          list: { type: 'default', value: '/modules/warn/warnList' }
        },
        formInputsData: [
          { name: '预警编号', key: 'id', value: '', type: 'text' },
          { name: '站点名称', key: 'siteName', value: '', type: 'text' },
          { name: '社区', key: 'communityName', value: '', type: 'text' },
          { name: '站长姓名', key: 'employeesName', value: '', type: 'text' },
          { name: '状态',
            key: 'state',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '待处理', value: 1 },
              { label: '已延迟', value: 2 },
              { label: '已解决', value: 3 }
            ] }],
        formButtonsData: [{ name: '导出',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/warn/warnListImport',
          fileName: '预警记录',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '预警编号', key: 'id', type: 'text' },
          { name: '站点名称', key: 'siteName', type: 'text' },
          { name: '站点地址', key: 'siteAddress', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '站长姓名', key: 'employeesName', type: 'text' },
          { name: '手机号', key: 'employeesPhone', type: 'text', width: 110 },
          { name: '垃圾类型', key: 'garbageName', type: 'text' },
          { name: '出库时间', key: 'updateTime', type: 'text', sortable: true, minWidth: 160 },
          { name: '出库当日（重量）', key: 'countCurrent', type: 'custom', width: 140 },
          { name: '实际出库（重量）', key: 'countReal', type: 'custom', width: 140 },
          { name: '预警值', key: 'warnCount', type: 'text' },
          { name: '状态', key: 'state', type: 'custom' }], // 预警状态 1待处理/2已延迟3/已解决
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonWidth: 130 }
      },
      formDialog: {
        visible: false,
        title: '',
        type: '',
        row: null,
        form: {
          reason: ''
        }
      }
    }
  },
  methods: {
    onButtonAction() {},
    toClickAction(row, type) {
      console.log(type)
      if (type === 'DELAY') {
        this.formDialog.visible = true
        this.formDialog.title = '延迟说明'
        this.formDialog.form.reason = ''
        this.formDialog.type = type
        this.formDialog.row = row
      }
      if (type === 'CONFIRM') {
        this.formDialog.visible = true
        this.formDialog.title = '解决说明'
        this.formDialog.form.reason = ''
        this.formDialog.type = type
        this.formDialog.row = row
      }
      if (type === 'VIEW') {
        this.$store.dispatch('setWarningRecordDetailData', JSON.parse(JSON.stringify(row)))
        this.$refs.warningRecordTableRef.toView({ action: type }, row)
      }
    },
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(that.formDialog.row))
          params.remark = that.formDialog.form.reason
          params.state = that.formDialog.type === 'DELAY' ? 2 : 3
          this.$api.warning.record.warnUpdate(params).then(res => {
            that.$message({ message: that.formDialog.type === 'DELAY' ? '延迟成功' : '解决成功', type: 'success' })
            that.$refs.warningRecordTableRef.requestList()
            that.handleDialogClose()
          })
        } else {
          return false
        }
      })
    },
    handleDialogClose() {
      this.formDialog.visible = false
    }
  }
}
</script>

<style>
</style>
